import gql from 'graphql-tag';

export const getNotifications = gql`
  query GetNotifications($input: GetNotificationInput!) {
    getNotifications(input: $input) {
      ... on AppNotification {
        message {
          body {
            content
            metadata
          }
          charset
        }
        notificationId
        status
        lastUpdated
        sentTime
        target
        metadata
      }
    }
  }
`;
